//import 'core-js/stable';

import axios from 'axios';
window.axios = axios;
import ScrollMagic from 'scrollmagic';
window.ScrollMagic = ScrollMagic;
import { debounce } from "debounce";
window.debounce = debounce;

// import * as THREE from 'three';
// import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
// import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
// import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js';
// //import { GlitchPass } from 'three/addons/postprocessing/GlitchPass.js';
// import { RGBShiftShader } from 'three/addons/shaders/RGBShiftShader.js';
// import { DotScreenShader } from 'three/addons/shaders/DotScreenShader.js';
// import { OutputPass } from 'three/addons/postprocessing/OutputPass.js';
// window.THREE = THREE;
// import { jarallax, jarallaxVideo } from 'jarallax';
// jarallaxVideo();

// import { Splide } from '@splidejs/splide';
// import { Video } from '@splidejs/splide-extension-video';
// import '@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css';

// new Splide( '.splide' ).mount( { Video } );
// window.Splide = Splide;
// window.Video = Video;

// import Splide from '@splidejs/splide';
// new Splide( '#splide' ).mount();
// import splideExtensionVideo from 'splide-extension-video';
// window.splideExtensionVideo = splideExtensionVideo;
// import Splide from '@splidejs/splide/dist/js/splide';
// import SplideExtensions from '@splidejs/splide-extension-video/dist/js/splide-extension-video';

import filterizr from 'filterizr';
window.Filterizr = filterizr;
import velocity from 'velocity-animate';
//import isWindows from 'cross-env/src/is-windows';
window.Velocity  = velocity;

//import lottie from 'lottie-web';
//import "@lottiefiles/lottie-player";
window.lottie = lottie; 
window.lotties = [];

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
window.Alpine = Alpine;

Alpine.plugin(intersect);
Alpine.start();


//page loaded let's go!
document.addEventListener("DOMContentLoaded", () => {

	// Main nav to transparent and sticky when desired
	window.onscroll = function() {
		const header = document.querySelector('.header'),
			logo = header.querySelector('#header-logo .logo'),
			scrolled = 'sticky';
		if (document.querySelector('.header-transparent')) {
			if (window.scrollY > 0) {
				header.classList.remove('border', 'lg:text-slate-500');
				header.classList.add('bg-slate-800/95');
			} 
			else {
				header.classList.remove('bg-slate-800/95', 'lg:text-white');
				header.classList.add('border');
			}
		}
	}

	// loading widget
	var replacers = document.querySelectorAll('[data-replace]');
	for(var i=0; i<replacers.length; i++){
		let replaceClasses = JSON.parse(replacers[i].dataset.replace.replace(/'/g, '"'));
		Object.keys(replaceClasses).forEach(function(key) {
			replacers[i].classList.remove(key);
			replacers[i].classList.add(replaceClasses[key]);
		});
	}

	// Carousel initiator
	if (document.querySelector('.carousel_splide')) {
		new Splide('.splide', {
			type: 'carousel',
			cover: true,
			rewind: true,
			heightRatio: '0.5',
			perPage: 1,
			// arrowPath: 'm0,0.707l20.248,20.248L0,41.202',
			gap: '0',
			padding: {
				left : '0',
				right: '0',
			},
			video: {
				autoplay: true,
				mute    : true,
			}
		}).mount(window.splide.Extensions);
	}


	// Set up any Parallax things
	const hasParallax = document.querySelector('.parallax');
	if (hasParallax) {
		const parallaxThing = document.querySelectorAll('.parallax');
		parallaxThing.forEach(function(pt) {
			const jarvsrc = pt.getAttribute('data-jarallax-video'),
				  jarspeed = pt.getAttribute('data-speed');
			jarallax(pt, {
				speed: jarspeed,
				videoSrc: jarvsrc
			});
		});
	}

	// Handle ajax for generic contact forms
	const formContact = document.querySelector('#formContact');
	if (formContact) {
		formContact.addEventListener('submit', event => {
			event.preventDefault();
			const formData = new FormData(formContact);
			// console.log('footer', formData);
			axios.post('/wheelform/message/send', formData)
				.then(function (response) {
					// console.log('resp', response);

					if (response.data.errors) {// display errors
						let errorsHTML = '',
							errors = Object.values(response.data.errors);
						for(let i = 0; i < errors.length; i++) {
							errorsHTML += '<p class="err">'+ errors[i] +'</p>';
						}
						document.querySelector(".errors").innerHTML = errorsHTML;
					} else {// display thank you
						document.getElementById("formContact").classList.add('hidden');
						document.getElementById("formContactThanks").classList.remove('hidden');
					}
				})
				.catch(function (error) {
					document.getElementById("formContact").innerHTML = '<div><h3>Sorry, there was an error.</h3><p>The following errors were encountered:</p><p class="text-red-800">'+ error +'</p></div>';
				});
		});
	}

	//formFooterSubscribe
	const formFooter = document.querySelector('#formFooter');
	if (formFooter) {
		formFooter.addEventListener('submit', event => {
			event.preventDefault();
			const formDataFooter = new FormData(formFooter);
			axios.post('/wheelform/message/send', formDataFooter)
				.then(function (response) {
					// console.log('resp', response);

					// It's 404ing on this but it's also working so just going to pretend there are never issues.

					if (response.data.errors) {// display errors
						let errorsHTML = '',
							errors = Object.values(response.data.errors);
						for(let i = 0; i < errors.length; i++) {
							errorsHTML += '<p class="err">'+ errors[i] +'</p>';
						}
						document.querySelector(".errors").innerHTML = errorsHTML;
					} else {// display thank you
						document.getElementById("formFooter").classList.add('hidden');
						document.getElementById("formFooterThanks").classList.remove('hidden');
					}
				})
				.catch(function (error) {
					document.getElementById("formFooter").innerHTML = '<div><h3>Sorry, there was an error.</h3><p>The following errors were encountered:</p><p class="text-red-800">'+ error +'</p></div>';
				});
		});
	}

});

